



























































































import { Vue, Component, Prop, p, Mixin } from "av-ts";
import ActionButtons from "./ActionButtons.vue";
import { IQuestionBuilder } from "../../interfaces/models";
import responsiveMixin from "../../responsiveMixin";

@Component({
    components: {
        ActionButtons
    }
})

export default class AdminButtons extends mixin(responsiveMixin, Vue) {
    @Prop showEdit = p<boolean>({
        required: true
    });

    @Prop id = p<number>({});

    @Prop prevQuestions = p<IQuestionBuilder[]>({});

    version: number = 0;

    back() {
        this.$emit("back");
    }

    saveQuestion() {
        this.$emit("saveQuestion");
    }

    deleteQuestion() {
        this.$emit("deleteQuestion");
    }

    editQuestion() {
        this.$emit("editQuestion");
    }

    versionChange() {
        this.$emit("version", this.version);
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/util/AdminButtons.vue